import React, {useState, useEffect, useRef} from 'react';
import './PriceListPage.scss';
import '../../assets/css/styles.css';
import {IoIosArrowDown, IoIosArrowUp} from 'react-icons/io';
import LogoGr from '../../../src/assets/images/COSMOTE_T_logo.png';
import LogoEn from '../../../src/assets/images/COSMOTE_LOGO_MG_EN.png';
import PricelistRevision from './PricelistRevision';
import axios from 'axios';
import locales from "../../assets/const/locales";
import {useSearchParams} from "react-router-dom";
import {SERVICE_ENDPOINTS} from "../../config/config";

const PriceListPage = () => {
    const [searchParams] = useSearchParams();
    const lang = (searchParams.get("lang")?.toLowerCase() === locales.ENGLISH) ? locales.ENGLISH : locales.GREEK;

    const [openItem, setOpenItem] = useState(0);
    const [openSubItem, setOpenSubItem] = useState(0);
    const [selectedDate, setSelectedDate] = useState('');
    const [dropdownSelectedDate, setDropdownSelectedDate] = useState("0");
    const [assetsResponse, setAssetsResponse] = useState();
    const [datesResponse, setDatesResponse] = useState();
    const [categoriesResponse, setCategoriesResponse] = useState();
    const [removeOld, setRemoveOld] = useState(false);
    const [selectedMtbId, setSelectedMtbId] = useState('');
    const isInitialized = useRef(false);
    const scrollRef = useRef(null)

    useEffect(() => {
        if (!isInitialized.current) {
            fetchCategories(`${SERVICE_ENDPOINTS.PRICE_LIST_CATEGORIES}`
                .replace('{lang}', lang));
            isInitialized.current = true;
        }
    }, []);
    useEffect(() => {
        if (selectedMtbId && selectedDate) {
            fetchAssets(`${SERVICE_ENDPOINTS.PRICE_LIST_REVISION}`
                .replace('{lang}', lang)
                .replace('{mtbId}', selectedMtbId)
                .replace('{version}', selectedDate), selectedMtbId);

        }
        scrollRef.current?.scrollIntoView(({ behavior: 'smooth' }));
    }, [lang, selectedDate, datesResponse]);

    useEffect(() => {
        const findFirstChildWithMtbId = (subCategories) => {
            for (let i = 0; i < subCategories.length; i++) {
                const subCategory = subCategories[i];
                if (subCategory.mtbId && (!subCategory.subCategories || subCategory.subCategories.length === 0)) {
                    return subCategory.mtbId;
                }
                if (subCategory.subCategories) {
                    const result = findFirstChildWithMtbId(subCategory.subCategories);
                    if (result) return result;
                }
            }
            return null;
        };

        let preselectedMtbId = searchParams.get("mtbid");
        if (preselectedMtbId) {
            fetchDates(`${SERVICE_ENDPOINTS.PRICE_LIST_VERSIONS}`, preselectedMtbId);
            setSelectedMtbId(preselectedMtbId);
            if (categoriesResponse?.categories?.length > 0) {
                findMtbIdIndex(categoriesResponse, preselectedMtbId);
            }

        } else if (categoriesResponse?.categories?.length > 0) {
            setOpenItem(0);
            const firstCategory = categoriesResponse.categories[0];
            if (firstCategory.subCategories?.length > 0) {
                setOpenSubItem(0);
                const mtbId = findFirstChildWithMtbId(firstCategory.subCategories);
                if (mtbId) {
                    fetchDates(`${SERVICE_ENDPOINTS.PRICE_LIST_VERSIONS}`, mtbId);
                    // fetchAssets(`${baseUrl}${assetsUrl}${mtbId}`, mtbId);
                }
            } else if (firstCategory.mtbId) {
                fetchDates(`${SERVICE_ENDPOINTS.PRICE_LIST_VERSIONS}`, firstCategory.mtbId)
                // fetchAssets(`${baseUrl}${assetsUrl}${firstCategory.mtbId}`, firstCategory.mtbId);
            }
        }
    }, [categoriesResponse]);


    // Function to find the mtbId index and sub-index
    // This is needed in order to expand the menu when url contains mtbId.
    const findMtbIdIndex = (data, targetMtbId) => {
        for (let categoryIndex = 0; categoryIndex < data.categories.length; categoryIndex++) {
            const category = data.categories[categoryIndex];

            // Check if mtbId matches in the subCategories of this category
            if (category.subCategories) {
                for (let subCategoryIndex = 0; subCategoryIndex < category.subCategories.length; subCategoryIndex++) {
                    const subCategory = category.subCategories[subCategoryIndex];
                    if (subCategory.mtbId === targetMtbId) {
                        setOpenItem(categoryIndex);
                        setOpenSubItem(null);
                        return;
                    }
                    if (subCategory.subCategories) {
                        for (let subCategoryIndex2 = 0; subCategoryIndex2 < subCategory.subCategories.length; subCategoryIndex2++) {
                            const subCategory2 = subCategory.subCategories[subCategoryIndex2];
                            if (subCategory2.mtbId === targetMtbId) {
                                setOpenItem(categoryIndex);
                                setOpenSubItem(subCategoryIndex);
                                return;
                            }
                        }
                    }
                }
            }
        }
    };

    const toggleItem = (index, mtbId) => {
        setOpenItem(openItem === index ? null : index);
        setOpenSubItem(null);
        if (!categoriesResponse?.categories[index]?.subCategories && mtbId) {
            // fetchAssets(`${baseUrl}${assetsUrl}${mtbId}`, mtbId);
            fetchDates(`${SERVICE_ENDPOINTS.PRICE_LIST_VERSIONS}`, mtbId);
            // fetchAssets(`${baseUrl}${revisionUrl}`.replace('{mtbId}', mtbId).replace('{version}', selectedDate), mtbId);

        }
    };

    const toggleSubItem = (index, mtbId, hasChildren) => {
        setOpenSubItem(openSubItem === index ? null : index);
        if (!hasChildren && mtbId) {
            // fetchAssets(`${baseUrl}${assetsUrl}${mtbId}`, mtbId);
            fetchDates(`${SERVICE_ENDPOINTS.PRICE_LIST_VERSIONS}`, mtbId);

            // fetchAssets(`${baseUrl}${revisionUrl}`.replace('{mtbId}', mtbId).replace('{version}', selectedDate), mtbId);

        }
    };

    const fetchCategories = (url) => {
        axios
            .get(url)
            .then((response) => {
                setCategoriesResponse(response.data);
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const fetchAssets = (url, mtbId) => {
        axios
            .get(url)
            .then((response) => {
                setAssetsResponse(response.data);
                // setSelectedDate(Object.keys(response?.data?.activationDates)[0]);
                // setRemoveOld(true);
                setSelectedMtbId(mtbId); // Update the selected menu item
            })
            .catch((error) => {
                console.error(error);
            });
    };
    const fetchDates = (url, mtbId) => {
        axios
            .get(url.replace('{lang}', lang).replace('{mtbId}', mtbId))
            .then((response) => {
                // Convert activationDates to an array and reverse it
                const orderedDates = Object.entries(response.data.activationDates).reverse();

                //keep previous url & params in that way
                const url = new URL(window.document.URL);
                url.searchParams.set("mtbid", mtbId);
                window.history.replaceState(null, "", url.toString());

                setDatesResponse({ ...response.data, orderedDates }); // Store reversed array
                setSelectedMtbId(mtbId);
                setSelectedDate(orderedDates[0]?.[0]); // Default to the first entry in reversed order
                setRemoveOld(true);
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const triggerKeepOnlyNew = () => {
        if (datesResponse?.orderedDates?.length > 0) {
            setSelectedDate(datesResponse.orderedDates[0][0]); // Select the first key from orderedDates
            setRemoveOld(true);
        }
        setDropdownSelectedDate("0")
    };


    const handleDateChange = (event) => {
        setRemoveOld(false);
        setSelectedDate(event.target.value);
        setDropdownSelectedDate(event.target.value)
    };

    return (
         <div className="price-list-page">
            <header className="header">
                <div className="header-logo">
                    <a href="https://www.cosmote.gr" target="_blank" rel="noopener noreferrer">
                        {(lang === locales.ENGLISH || lang === 'En' || lang === 'EN') ? <img src={LogoEn} alt="COSMOTE"/> : <img src={LogoGr} alt="COSMOTE"/>}
                    </a>
                </div>
                <h1 className="header-title">{(lang === locales.ENGLISH || lang === 'En' || lang === 'EN') ? 'Pricelist' : 'Αναλυτικός Τιμοκατάλογος'}</h1>
            </header>

             {categoriesResponse ? <div className="main-container">
                <aside className="sidebar">
                    {categoriesResponse?.categories.map((item, index) => (
                        <div className="sidebar-item" key={index}>
                            <div
                                className={`sidebar-item-label ${item.mtbId === selectedMtbId ? 'selected' : ''}`}
                                onClick={() => toggleItem(index, item.mtbId)}
                            >
                                {item.title}
                                <span className="icon">
                                    {openItem === index ? <IoIosArrowUp/> : <IoIosArrowDown/>}
                                </span>
                            </div>
                            {openItem === index && (
                                <div className="sidebar-item-children">
                                    {item?.subCategories &&
                                        item?.subCategories.map((subItem, subIndex) => (
                                            <div key={subIndex}>
                                                <div
                                                    className={`submenu-label ${subItem.mtbId === selectedMtbId ? 'selected' : ''}`}
                                                    onClick={() =>
                                                        toggleSubItem(
                                                            subIndex,
                                                            subItem.mtbId,
                                                            subItem?.subCategories?.length > 0
                                                        )
                                                    }
                                                >
                                                    {subItem?.title}
                                                    {subItem?.subCategories && (
                                                        <span className="icon">
                                                            {openSubItem === subIndex ? (
                                                                <IoIosArrowUp/>
                                                            ) : (
                                                                <IoIosArrowDown/>
                                                            )}
                                                        </span>
                                                    )}
                                                </div>
                                                {subItem?.subCategories &&
                                                    openSubItem === subIndex && (
                                                        <ul className="submenu">
                                                            {subItem?.subCategories.map((subChild, childIndex) => (
                                                                <li
                                                                    key={childIndex}
                                                                    className={subChild.mtbId === selectedMtbId ? 'selected' : ''}
                                                                    onClick={() => {
                                                                        if (!subChild?.subCategories && subChild?.mtbId) {
                                                                            // fetchAssets(
                                                                            //     `${baseUrl}${revisionUrl}`.replace('{mtbId}', subChild.mtbId).replace('{version}', selectedDate),
                                                                            //     subChild.mtbId
                                                                            // );
                                                                            fetchDates(`${SERVICE_ENDPOINTS.PRICE_LIST_VERSIONS}`, subChild.mtbId);

                                                                        }
                                                                    }}
                                                                >
                                                                    {subChild?.title}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    )}
                                            </div>
                                        ))}
                                </div>
                            )}
                        </div>
                    ))}
                </aside>

                <div className="content">
                    {assetsResponse && (
                        <>
                            <div ref={scrollRef} className="additional-info-section">
                                <div className="additional-info-header">
                                    {(lang === locales.ENGLISH || lang === 'En' || lang === 'EN') ? 'Detailed Mobile Pricelist' : 'Αναλυτικός Τιμοκατάλογος Κινητής'}
                                </div>
                                <div className="additional-info-content">
                                    <label>
                                        <b>{(lang === locales.ENGLISH || lang === 'En' || lang === 'EN') ? 'Select previous versions here' : 'Για να δείτε τις προηγούμενες εκδόσεις επιλέξτε εδώ'}</b>
                                    </label>
                                    &nbsp;
                                    <select
                                        id="dateSelection"
                                        name="dateSelection"
                                        value={dropdownSelectedDate}
                                        onChange={handleDateChange}
                                    >
                                        <option key="0" hidden={true} value={datesResponse?.orderedDates[0][1]}>
                                            {datesResponse?.orderedDates[0][1]}
                                        </option>
                                        {datesResponse?.orderedDates?.map(([key, value]) => (
                                            <option key={key} value={key}>
                                                {value}
                                            </option>
                                        ))}
                                    </select>
                                    <div>
                                        {(lang === locales.ENGLISH || lang === 'En' || lang === 'EN') ? 'To return to the latest version ' : 'Για επιστροφή στην πιο πρόσφατη έκδοση '}
                                        <a style={{color: '#509e2f'}} onClick={triggerKeepOnlyNew}>
                                            {(lang === locales.ENGLISH || lang === 'En' || lang === 'EN') ? 'click here' : 'πατήστε εδώ'}
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="section-table">
                                <PricelistRevision
                                    json={assetsResponse}
                                    revision={selectedDate}
                                    removeOld={removeOld}
                                />
                            </div>
                        </>
                    )}
                </div>
             </div> : <div className="main-container centered" style={{width: '80%'}}>
                 {(lang === locales.ENGLISH || lang === 'En' || lang === 'EN') ? 'Loading data...' : 'Αναζήτηση Δεδομένων...'}</div>}

            <footer className="footer"></footer>
        </div>
    );
};

export default PriceListPage;
